<template>
  <img
    :class="getClassName"
    @click="click"
    width="100%"
    :src="getIcon" />

</template>

<script>
export default {
  props: {
    spin: {
      type: Boolean,
      required: false,
      default: false
    },
    allowSelfUpdate: {
      type: Boolean,
      required: false,
      default: true
    },
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    className: {
      type: String,
      required: false,
      default: ''
    },

    altPack: {
      type: String,
      required: false,
      default: 'leftMenu'
    },

    altName: {
      type: String,
      required: false,
      default: ''
    },

    // Determines witch pack of icons to use...
    pack: {
      type: String,
      required: false,
      default: 'leftMenu'
    },

    // Determines what icon from that pack to use...
    name: {
      type: String,
      required: true,
      default: ''
    }
  },
  methods: {
    click (e) {
      if (this.allowSelfUpdate) {
        this.active = !this.active
      }
      this.$emit('click', {click: true, active: this.active})
    }
  },
  computed: {
    getClassName () {
      let base = this.className

      if (this.spin) {
        base += ' spinner'
      }
      return base
    },
    getIcon () {
      if (this.active) {
        return ((this.$store.getters.icons || {})[this.altPack] || {})[this.altName]
      }
      return ((this.$store.getters.icons || {})[this.pack] || {})[this.name]
    }
  }
}
</script>

<style scoped>
.spinner{
  -webkit-transition-property: -webkit-transform;
  -webkit-transition-duration: 1s;
  -moz-transition-property: -moz-transform;
  -moz-transition-duration: 1s;
  transition-property: transform;
  transition-duration: 1s;
}
.spinner {
  -webkit-animation-name: rotate; 
  -webkit-animation-duration: 2s; 
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-name: rotate; 
  -moz-animation-duration: 2s; 
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;
  animation-name: rotate; 
  animation-duration: 2s; 
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@-webkit-keyframes rotate {
  from {-webkit-transform: rotate(0deg);}
  to {-webkit-transform: rotate(360deg);}
}

@-moz-keyframes rotate {
  from {-moz-transform: rotate(0deg);}
  to {-moz-transform: rotate(360deg);}
}

@keyframes rotate {
  from {transform: rotate(0deg);}
  to {transform: rotate(360deg);}
}

</style>



// WEBPACK FOOTER //
// src/components/standard/display/QIcon.vue?26ea3128